import { useMemo } from 'react';

import { useApplicationContext } from '~/shared/context/use-application-context';

import { getUserName } from '../../app/common/user';
import type { LearningOpportunity } from '../data-contract';
import {
    createEmptyFormState,
    type LearningOpportunityFormState,
    mapOpportunityToFormState,
    type SidepanelMode,
} from '../form-state';

export const useFormDefaultValue = (
    initialMode: SidepanelMode,
    data: LearningOpportunity | undefined,
): LearningOpportunityFormState | undefined => {
    const {
        applicationState: { availableLanguages, myUserProfile },
    } = useApplicationContext();
    const fullName = getUserName(myUserProfile);
    const contentLanguageCodes = useMemo(
        () => Object.values(availableLanguages).map((item) => item.code),
        [availableLanguages],
    );

    return useMemo(() => {
        if (initialMode === 'create') {
            return createEmptyFormState(fullName, contentLanguageCodes);
        }
        return data === undefined ? undefined : mapOpportunityToFormState(data, fullName, contentLanguageCodes);
    }, [contentLanguageCodes, data, fullName, initialMode]);
};
